export default __webpack_public_path__ + "static/media/picHungLuong.7159f609.png";